import {
  FaWhatsapp,
  FaTelegramPlane,
  FaLinkedinIn,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";
import conf from "../../conf/conf";
import { FaXTwitter } from "react-icons/fa6";

export default function SocialBar() {
  const whatsappLink = conf.whatsapp_url;
  const telegramLink = conf.telegram_url;
  const instagramLink = conf.instagram_url;
  const twitterLink = conf.twitter_url;
  const linkedinLink = conf.linkedin_url;
  const email_id = conf.email_id;

  return (
    <div className="fixed right-4 top-1/3 flex flex-col items-center gap-4 z-50">
      {/* WhatsApp */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-green-600 transition-transform"
      >
        <FaWhatsapp size={20} />
      </a>

      {/* Telegram */}
      <a
        href={telegramLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-sky-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-sky-600 transition-transform"
      >
        <FaTelegramPlane size={20} />
      </a>

      {/* Twitter */}
      <a
        href={twitterLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-400 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-blue-500 transition-transform"
      >
        <FaXTwitter size={20} />
      </a>

      {/* LinkedIn */}
      <a
        href={linkedinLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-blue-700 transition-transform"
      >
        <FaLinkedinIn size={20} />
      </a>

      {/* Instagram */}
      <a
        href={instagramLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-pink-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-pink-600 transition-transform"
      >
        <FaInstagram size={20} />
      </a>

      <a
        href={`mailto:${email_id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-orange-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:bg-orange-600 transition-transform"
      >
        <FaEnvelope size={20} />
      </a>
    </div>
  );
}
